export const CART_CARD_CSS = /* css */ `
  .lk-cart-card {
    width: 100%;
    max-width: 304px;
    border-radius: 14px;
    overflow: hidden;
    background: var(--wg-bg);
    box-shadow: var(--wg-card-shadow);
    margin: 8px 0;
    animation: lk-card-in 0.4s ease backwards;
    transition: transform 0.15s ease-out, box-shadow 0.15s ease-out;
  }
  .lk-cart-card:hover {
    transform: scale(1.02);
    box-shadow: var(--wg-card-shadow-hover);
  }
  .lk-cart-card-header {
    padding: 14px 14px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .lk-cart-card-title {
    font-size: 14px;
    font-weight: 600;
    color: var(--wg-card-fg);
  }
  .lk-cart-card-badge {
    font-size: 12px;
    font-weight: 600;
    color: var(--wg-card-fg-muted);
  }
  .lk-cart-card-items {
    padding: 10px 14px;
    display: flex;
    flex-direction: column;
  }
  .lk-cart-card-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 0;
  }
  .lk-cart-card-item + .lk-cart-card-item {
    border-top: 1px solid var(--wg-border);
  }
  .lk-cart-card-thumb {
    width: 40px;
    height: 40px;
    border-radius: 6px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-color: #f8f8f8;
    flex: 0 0 auto;
  }
  .lk-cart-card-item-info {
    flex: 1 1 auto;
    min-width: 0;
  }
  .lk-cart-card-item-name {
    font-size: 13px;
    font-weight: 600;
    line-height: 1.3;
    color: var(--wg-card-fg);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .lk-cart-card-item-variant {
    font-size: 11px;
    font-weight: 400;
    line-height: 1.3;
    color: var(--wg-card-fg-muted);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .lk-cart-card-item-price {
    flex: 0 0 auto;
    font-size: 12px;
    font-weight: 500;
    color: var(--wg-card-fg);
    white-space: nowrap;
  }
  .lk-cart-card-footer {
    padding: 0 14px 14px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .lk-cart-card-total-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 4px;
    border-top: 1px solid var(--wg-border);
  }
  .lk-cart-card-total-label {
    font-size: 13px;
    font-weight: 500;
    color: var(--wg-card-fg-muted);
  }
  .lk-cart-card-total {
    font-size: 20px;
    font-weight: 700;
    letter-spacing: -0.4px;
    color: var(--wg-card-fg);
  }
  .lk-cart-card-cta {
    display: block;
    padding: 10px 20px;
    background: var(--wg-cta-bg);
    color: var(--wg-fg);
    font-size: 13px;
    font-weight: 600;
    line-height: 1.3;
    letter-spacing: -0.13px;
    border-radius: 999px;
    text-align: center;
    text-decoration: none;
  }
  .lk-cart-card-cta:hover {
    background: var(--wg-cta-bg-hover);
  }
`;
